import axios from 'axios'
import _ from 'lodash'

// Add imports for logout functionality
import store from '../store'
import { logoutUser } from '../actions/authActions'

// Setup interceptor once when module loads
let isInterceptorSetup = false
let isLoggingOut = false

const setupInterceptor = () => {
    if (isInterceptorSetup) return

    axios.interceptors.response.use(
        // Success response - just return as is
        response => response,

        // Error response - check for 401/403
        error => {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                // Skip logout for login/register endpoints to avoid logout loops
                const skipUrls = ['/login', '/register', '/forgot_password', '/reset_password', '/verify_email']
                const isAuthEndpoint = skipUrls.some(url => error.config?.url?.includes(url))

                if (!isAuthEndpoint && !isLoggingOut && localStorage.getItem('AuthToken')) {
                    isLoggingOut = true

                    console.warn(`[${error.response.status} Error] Session expired or unauthorized. Logging out user...`)

                    // Clear all auth tokens
                    localStorage.removeItem('AuthToken')
                    localStorage.removeItem('ProxyUserToken')

                    // Dispatch logout action to clean Redux state
                    store.dispatch(logoutUser())

                    // Redirect to login after short delay
                    setTimeout(() => {
                        window.location.href = '/login'
                        isLoggingOut = false
                    }, 2000)
                }
            }

            return Promise.reject(error)
        }
    )

    isInterceptorSetup = true
}

// Call setup immediately when this module is imported
setupInterceptor()

const setAuthToken = token => {
    if (token) {
        const proxyUserToken = localStorage.getItem('ProxyUserToken')
        // Apply authorization token to every request if logged in
        if (token.startsWith('ff_')) {
            axios.defaults.headers.common['token'] = token
        } else {
            axios.defaults.headers.common['Authorization'] = token
        }
        if (!_.isEmpty(proxyUserToken)) {
            //Apply authorization token to proxy user is logged in 
            axios.defaults.headers.common['Authorization'] = proxyUserToken
        }
    } else {
        // Delete auth header
        delete axios.defaults.headers.common['Authorization']
    }
}

export default setAuthToken
